// plugins/api.ts
import { $fetch } from 'ofetch'
import { useRuntimeConfig } from '#imports'

export default defineNuxtPlugin(() => {
  const { public: pub } = useRuntimeConfig()

  // WordPress (test)
  const wpApi = $fetch.create({
    baseURL: (pub.wpBase || 'https://testsurfsup.tvmarkets.com').replace(/\/$/, ''),
  })

  // API Gateway (debe incluir /prod en el env)
  const coreApi = $fetch.create({
    baseURL: (pub.apiBase || '').replace(/\/$/, ''),
  })

  return {
    provide: { wpApi, coreApi }
  }
})
